import { PageLoader } from '@diamond/shared/ui';

import { BuyerLayout } from './BuyerLayout';

interface BuyerPageLoaderProps {
  text?: string;
}

export const BuyerPageLoader = ({ text }: BuyerPageLoaderProps) => {
  return (
    <BuyerLayout>
      <PageLoader text={text} />
    </BuyerLayout>
  );
};
